import { useEffect, useState } from "react";
import './anylitics.scss';
import LayoutContainer from "../../components/Containers/LayoutContainer";
import NewCard from "../newCardComponent/NewCardComponent";
import { faDownload, faUsers } from "@fortawesome/free-solid-svg-icons";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { useAppDispatch } from "../../store/storeRequests";
import { postDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver'; // This helps save the file in the browser

interface CardData {
  title: string;
  mainValue: number;
  subValues: { label: string; value: number; type: string }[];
  backgroundColor: string;
  icon?: any;
  width?: string;
  height?: string;
}

const Anylitics: React.FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const [cardData, setCardData] = useState<CardData[]>([]);

  useEffect(() => {
    fetchAnalyticsData();
  }, []);

  const fetchAnalyticsData = async () => {
    try {
      dispatch(showLoader("Loading Data..."));

      const response: any = await postDetails(APIList.ANALYTICS_GET, {});

      const data = response.data[0];


      const formattedCardData = [
        {
          title: 'TOTAL AUDIENCE',
          mainValue: data.totalAudience?.totalAudience || 0,
          subValues: [
            { label: 'PEOPLE REPORT', value: data.totalAudience?.peopleReport || 0, type: 'total' },
          ],
          backgroundColor: '#313131',
          icon: faUsers,
          // width:"200px",
        },
        {
          title: 'TOTAL LOGGED IN',
          mainValue: data.totallogedIn?.totallogedIn || 0,
          subValues: [
            { label: 'ANDROID', value: data.totallogedIn?.Androidlogedin || 0, type: 'loginAndroid' },
            { label: 'IOS', value: data.totallogedIn?.ioslogedin || 0, type: 'loginios' },
          ],
          backgroundColor: '#78CD51',

        },
        {
          title: 'QUIZ REPORT',
          mainValue: data.totalsession?.totalsession || 0,
          subValues: [
            { label: 'QUESTION', value: data.totalsession?.getquizquiz || 0, type: 'question' },
            { label: 'FOLDER', value: data.totalsession?.getquizfolder || 0, type: 'folder' },
            { label: 'REPLY', value: data.totalsession?.quizReply || 0, type: 'quizreply' },
          ],
          backgroundColor: '#428BCA',

        },
        {
          title: 'PROFILE VIEWED',
          mainValue: data.totalViewreport
            ?.profileView || 0,
          subValues: [
            { label: 'PEOPLE', value: data.totalViewreport?.people || 0, type: 'profileview' },
          ],
          backgroundColor: '#1D2939',
          icon: faUsers,

        },
        {
          title: 'NETWORKING',
          mainValue: data.totalnotification?.networking || 0,
          subValues: [
            { label: 'NOTIFICATIONS', value: data.totalnotification?.getnotification || 0, type: 'notification' },
          ],
          backgroundColor: '#4DB6AC',
          width: "310px",
        },
        {
          title: 'CONTEST',
          mainValue: data.totalcontest?.totalcontest || 0,
          subValues: [
            { label: 'JIGSAW PUZZLE', value: data.totalcontest?.getJigsaw || 0, type: 'jigsaw' },
            { label: 'JIGSAW REPLY', value: data.totalcontest?.getJigsawReply || 0, type: 'jigsawreply' },
            { label: 'PHOTO CHALLENGE', value: data.totalcontest?.getPchallange || 0, type: 'photochallenge' },
            { label: 'PHOTO CHALLENGE LIKES', value: data.totalcontest?.getPchallangeLike || 0, type: 'Photolike' },
            { label: 'VIDEO CHALLENGE', value: data.totalcontest?.getVchallange || 0, type: 'videochallenge' },
            {
              label: 'VIDEO CHALLENGE LIKES', value: data.totalcontest?.getVchallangeLike
                || 0, type: 'videolike'
            },
          ],
          backgroundColor: '#32618B',
          width: "850px",
          // height:"220px"
        },
        {
          title: 'WALL REPORT',
          mainValue: data.totalwalReport?.
            walReportl || 0,
          subValues: [
            { label: 'IMAGES POSTED', value: data.totalwalReport?.getwallimage || 0, type: 'Image' },
            { label: 'VIDEO POSTED', value: data.totalwalReport?.getwallvideo || 0, type: 'Video' },
            { label: 'COMMENTS', value: data.totalwalReport?.getWallComment || 0, type: 'comment' },
            { label: 'LIKES', value: data.totalwalReport?.getWallLike || 0, type: 'like' },
            { label: 'STATUS POSTED', value: data.totalwalReport?.getStatusPosted || 0, type: 'statusposted' },
          ],
          backgroundColor: '#1D2939',

          icon: faUsers,
          width: "580px"
        },
        {
          title: 'CULTURAL CLUB REPORT',
          mainValue: data.totalCCRepost?.CCRepost || 0,
          subValues: [
            { label: 'IMAGES POSTED', value: data.totalCCRepost?.getCCimage || 0, type: 'Image' },
            { label: 'VIDEO POSTED', value: data.totalCCRepost?.getCCvideo || 0, type: 'Video' },
            { label: 'COMMENTS', value: data.totalCCRepost?.getccComment || 0, type: 'comment' },
            { label: 'LIKES', value: data.totalCCRepost?.getccLike || 0, type: 'like' },
            { label: 'STATUS POSTED', value: data.totalCCRepost?.getCCStatusPosted || 0, type: 'statusposted' },

          ],
          backgroundColor: '#007BB5',
          icon: faUsers,
          width: "580px"
        },





      ];


      setCardData(formattedCardData);

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dispatch(hideLoader());
    }
  };


  const handleValueClick = async (type: string, title: string, subLabel: string) => {
    const payload = { contentType: type }; // Payload based on type clicked

    try {
      dispatch(showLoader("Sending data..."));

      let response;


      switch (title) {
        case 'WALL REPORT':
          response = await postDetails(APIList.ANALYTICS_WALL_DATA, payload);
          break;
        case 'CULTURAL CLUB REPORT':
          response = await postDetails(APIList.ANALYTICS_CULTURAL_CLUB_DATA, payload);
          break;
        case 'NETWORKING':
          response = await postDetails(APIList.ANALYTICS_NOTIFICATION_DATA, payload);
          break;
        case 'CONTEST':
          response = await postDetails(APIList.ANALYTICS_CONTEST_DATA, payload);
          break;
        case 'QUIZ REPORT':
          response = await postDetails(APIList.ANALYTICS_SESSION_DATA, payload)
          break;
        case 'TOTAL AUDIENCE':
          response = await postDetails(APIList.ANALYTICS_PEOPLE_DATA, payload)
          break;
        case 'TOTAL LOGGED IN':
          response = await postDetails(APIList.ANALYTICS_PEOPLE_DATA, payload)
          break;
        case 'PROFILE VIEWED':
          response = await postDetails(APIList.ANALYTICS_PEOPLE_DATA, payload)
          break;
        default:
          console.error("Unknown card title");
          return;
      }



      if (response && response.data) {
        const worksheet = XLSX.utils.json_to_sheet(response.data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Analytics Data");

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const fileBlob = new Blob([excelBuffer], { type: "application/octet-stream" });

        saveAs(fileBlob, `${title}_${subLabel}_Report.xlsx`);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dispatch(hideLoader());
    }
  };



  return (
    <LayoutContainer title={"Training"}>
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-chart-column"></i>
          Analytics
        </h2>
      </div>
      <div className="analyticsSubHeader">
        <span style={{ display: 'inline' }}>Kindly Note - </span>
        <p style={{ display: 'inline', marginLeft: '5px' }}>
          while exporting files for (Messages,Profile Update,Image Posted,Like,Comment,Profile Viewed,Quiz..) , only last 3 month records will be available - for older records contact Asmadiya team.</p>
      </div>
      <div className="container">
        <div className="row">
          {cardData.length > 0 ? (
            cardData.map((card, index) => (
              <NewCard
                key={index}
                title={card.title}
                mainValue={card.mainValue}
                subValues={card.subValues}
                width={card.width}
                height={card.height}
                icon={card.icon}
                backgroundColor={card.backgroundColor}
                handleValueClick={handleValueClick}
              />
            ))
          ) : (
            // <p>No data available</p>
            <p></p>
          )}
        </div>
      </div>
    </LayoutContainer>
  );
};

export default Anylitics;